import { FormState, Radio, RadioGroup } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { messages } from './messages'
import styles from './styles.css'

const EQUALS_CONFIG = 'equals'

type Props = {
  state: FormState
}

export function Equals(props: Props) {
  const { state } = props
  const { $t } = useIntl()

  return (
    <RadioGroup
      name={EQUALS_CONFIG}
      label={
        <div className={styles.radioGroupLabel}>
          {$t(messages.equals.group)}
        </div>
      }
      state={state}
    >
      {[false, true].map((value) => (
        <Radio
          key={String(value)}
          label={$t(messages.equals.radio, { value })}
          value={String(value)}
        />
      ))}
    </RadioGroup>
  )
}
